const NAME = "AdminNavigationModule";

export const SET_ADMIN_NAVIGATION_NODES =
  "SET_ADMIN_NAVIGATION_NODES" + " " + NAME;

export const SET_CHILD_ID = "SET_CHILD_ID" + " " + NAME;

export const SET_PARENT_NODE_DETAILS = "SET_PARENT_NODE_DETAILS" + " " + NAME;

export const SET_PREVIOUSLY_VISITED_NODES =
  "SET_PREVIOUSLY_VISITED_NODES" + " " + NAME;

export const SET_DIALOG_DETAILS = "SET_DIALOG_DETAILS" + " " + NAME;
